/*** IMPORTS FROM imports-loader ***/
var define = false;

require('../../modules/es7.symbol.async-iterator');
module.exports = require('../../modules/_wks-ext').f('asyncIterator');

